import React, { useState } from 'react';
import { Box, Stack, Tab, Tabs, TextField } from '@mui/material';
import OrganizationsTable from '../components/OrganizationsTable';
import PendingSignupsTable from '../components/PendingSignupsTable';
import TopBar from '../../../components/TopBar';
import OrganizationListPageActions from '../components/OrganizationListPageActions';
import useOrganizationFilters from '../components/OrganizationFilterHelper';

const OrganizationListPage = () => {
  const [activeTab, setActiveTab] = useState('active');

  const { searchTerm, currentQuery, pagination, handleSearchChange, handleSearchKeyDown, handlePaginationChange } =
    useOrganizationFilters({ defaultQuery: {} });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title="Organizations">
        <OrganizationListPageActions />
      </TopBar>

      <Tabs
        value={activeTab}
        onChange={(_, value) => {
          setActiveTab(value);
          handlePaginationChange(0, pagination.size);
        }}
        sx={{ mb: 2 }}
      >
        <Tab value="active" label="Active" />
        <Tab value="pending" label="Pending" />
      </Tabs>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <TextField
          label="Search by name or email"
          placeholder="Search by name or email"
          value={searchTerm}
          onChange={(event) => handleSearchChange(event.target.value)}
          onKeyDown={handleSearchKeyDown}
          size="small"
          sx={{ width: 320 }}
        />
      </Box>

      {activeTab === 'active' ? (
        <OrganizationsTable
          handlePaginationChange={handlePaginationChange}
          searchQuery={currentQuery}
          paginationModel={{ page: pagination.page, pageSize: pagination.size }}
        />
      ) : (
        <PendingSignupsTable
          handlePaginationChange={handlePaginationChange}
          searchQuery={currentQuery}
          paginationModel={{ page: pagination.page, pageSize: pagination.size }}
        />
      )}
    </Stack>
  );
};

export default OrganizationListPage;
